import { render, staticRenderFns } from "./manydetail.vue?vue&type=template&id=86caf362&scoped=true&"
import script from "./manydetail.vue?vue&type=script&lang=js&"
export * from "./manydetail.vue?vue&type=script&lang=js&"
import style0 from "./manydetail.vue?vue&type=style&index=0&id=86caf362&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86caf362",
  null
  
)

export default component.exports